import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '../../interfaces/user.interface';
import { AuthService } from '../../services/auth/auth.service';
import { BroadcastService } from '../../services/broadcast/broadcast.service';
import {
  AppLanguage,
  LanguageService,
  SUPPORTED_LANGUAGES,
} from '../../services/language/language.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
})
export class NavbarComponent implements OnInit {
  currentUser: IUser | null = null;
  readonly languages = SUPPORTED_LANGUAGES;

  constructor(
    public location: Location,
    private router: Router,
    private authService: AuthService,
    private broadcastService: BroadcastService,
    private languageService: LanguageService,
  ) {}

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
  }

  toggleSidebar(): void {
    this.broadcastService.broadcast('sidebar:toggle');
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    this.router.navigate(['/login']);
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  get currentLanguage(): AppLanguage {
    return this.languageService.current();
  }

  async changeLanguage(language: AppLanguage): Promise<void> {
    this.languageService.use(language);
    if (this.currentUser) {
      this.currentUser = await this.authService.updateLanguage(language);
    }
    window.location.reload();
  }

  get userInitials(): string {
    if (!this.currentUser) {
      return '';
    }

    const initials = [this.currentUser.name, this.currentUser.surname]
      .filter(Boolean)
      .map((value) => value.trim().charAt(0).toUpperCase())
      .join('');

    return initials.slice(0, 2);
  }
}
